export default __webpack_public_path__ + "static/media/pluswhite.0023fb47.svg";